import { ISemSimplifiedLpXP } from "@faire/web-api/indigofair/seo/ISemSimplifiedLpXP";

export const checkIsSemTraffic = (
  searchParams: Pick<URLSearchParams, "get">
): boolean => {
  return (searchParams || { get: () => null }).get("utm_medium") === "cpc";
};

interface IsSettingSemSimplifiedLpEnabledParams {
  settingVariant: keyof typeof ISemSimplifiedLpXP.Bucket;
  searchParams: Pick<URLSearchParams, "get">;
  isLoggedOutDiscoverPage: boolean;
}

export const getIsSettingSemSimplifiedLpEnabled = ({
  settingVariant,
  searchParams,
  isLoggedOutDiscoverPage,
}: IsSettingSemSimplifiedLpEnabledParams): boolean => {
  return (
    settingVariant === ISemSimplifiedLpXP.Bucket.VARIANT_A &&
    checkIsSemTraffic(searchParams) &&
    isLoggedOutDiscoverPage
  );
};
